import { createSlice } from "@reduxjs/toolkit";
import { post, get } from "../api/http";
import ServerRoutes from "../api/routes";

const initialState = {
  data: {},
  dataError: null,
  dataLoading: false,
};

const _actionStart = (state) => {
  state.dataLoading = true;
  state.dataError = null;
};

const _actionSuccess = (state) => {
  state.dataLoading = false;
  state.dataError = null;
};

const _deleteMsg = (state, action) => {
  let editedMsgs = { ...state.data };
  delete editedMsgs[action.payload];
  state.data = editedMsgs;
};

const _actionFailed = (state, action) => {
  state.dataLoading = false;
  state.dataError = action.payload.error;
};

const _setData = (state, action) => {
  state.data = action.payload;
};

const _cleanDataState = (state) => {
  state.data = {};
  state.dataError = null;
  state.dataLoading = false;
};

const data = createSlice({
  name: "data",
  initialState,
  reducers: {
    cleanDataState: _cleanDataState,
    setData: _setData,
    deleteMsg: _deleteMsg,
    actionStart: _actionStart,
    actionFailed: _actionFailed,
    actionSuccess: _actionSuccess,
  },
});

const { reducer, actions } = data;

const { actionStart, actionFailed, actionSuccess, deleteMsg, setData } =
  actions;

export default reducer;

// export const cleanAll = () => {
//   return async (dispatch) => {
//     return dispatch(cleanDataState());
//   };
// };

export const countNotAnswered = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(
      ServerRoutes.Guests.countNotAnswered,
      body
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(actionSuccess(data));
  };
};

export const getPaymentDetails = () => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await get(
      ServerRoutes.User.getPaymentDetails,
      {}
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(actionSuccess(data));
  };
};

export const getNews = () => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await get(ServerRoutes.News.getAll, {});
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(actionSuccess(data));
  };
};

export const deleteNews = (id) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(ServerRoutes.News.delete, { id });
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      return dispatch(actionSuccess());
    }
  };
};

//sss

export const sendSms = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(ServerRoutes.Sms.send, body);
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(actionSuccess());
  };
};

export const sendSmsScheduled = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(
      ServerRoutes.SmsScheduled.schedule,
      body
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(actionSuccess());
  };
};

export const sendGenericSms = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(
      ServerRoutes.Sms.sendGeneric,
      body
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(actionSuccess());
  };
};

export const syncSeatup = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(
      ServerRoutes.Guests.syncSeatup,
      body
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(actionSuccess());
  };
};

export const getPhoneNumber = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(
      ServerRoutes.User.getPhoneNumber,
      body
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(actionSuccess(data));
  };
};

export const sendWhatsapp = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(
      ServerRoutes.Whatsapp.send,
      body
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(actionSuccess());
  };
};

export const setCallsRecord = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(ServerRoutes.Records.add, body);
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(actionSuccess(data));
  };
};

export const getByMonth = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(
      ServerRoutes.Records.getByMonth,
      body
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(actionSuccess(data));
  };
};

export const getTTodos = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await get(
      ServerRoutes.Records.getTTodos,
      body
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      console.log("sss :", data);

      return dispatch(actionSuccess(data));
    }
  };
};

export const getTals = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await get(
      ServerRoutes.Records.getTals,
      body
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(actionSuccess(data));
  };
};

export const getMsgs = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await get(
      ServerRoutes.Answers.getAll,
      body
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      dispatch(actionSuccess());
      return dispatch(setData(data));
    }
  };
};

export const deleteMsgs = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(
      ServerRoutes.Answers.delete,
      body
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      dispatch(deleteMsg(body.id));
      return dispatch(actionSuccess());
    }
  };
};
